/**
 * Utility functions for itemized bill request logic
 * Ported from Laravel RequestItemizedBillsJob
 */

export function fiveBusinessDaysFrom(ref: Date = new Date()): Date {
  let days = 0;
  const d = new Date(ref);
  
  while (days < 5) {
    d.setDate(d.getDate() + 1);
    const dayOfWeek = d.getDay(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      days++;
    }
  }

  return d;
}

export function formatRequestDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

/**
 * Check if at least 5 business days have passed since the given date.
 * @param fromDate The date to check from
 * @param now Optional current date (defaults to new Date())
 * @returns true if 5 or more business days have passed
 */
export function hasAtLeastFiveBusinessDaysPassed(fromDate: Date, now: Date = new Date()): boolean {
  const fiveBusinessDaysLater = fiveBusinessDaysFrom(fromDate);
  return now >= fiveBusinessDaysLater;
}